'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerTextContainer = renderWithRef('BannerTextContainer', null, (n, t)=>{
    let { children: o } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-banner-text-container'
        ],
        props: n,
        children: o
    });
});

export { BannerTextContainer };
